export const getUserGroupsFrag = `
    userId
    organizationId
    data
    group {
        id
        isPrivate
        rules {
            resource
            action
        }
    }
`;
